export function participantEntitiesSelector(state) {
  return state.entities.participants
}
